import React from "react";
import PropTypes from "prop-types";
import EMPStatusCard from "../../../shared/components/EMPStatusCard/EMPStatusCard";
import { withTranslation } from "react-i18next";
import DeliveryStatuses from "../../../utils/DeliveryStatusUtils/DeliveryStatuses";

const Delivery = () => {
  const { message } = DeliveryStatuses.deliveryNotScheduled;

  return <EMPStatusCard cardTitle={message} status="default" />;
};

Delivery.propTypes = {
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func,
};

export default withTranslation("emp")(Delivery);
